import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CTASection } from "@/components/CTASection";
import { Manifesto } from "@/components/Manifesto";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div data-testid="pusatcuan-app" className="min-h-screen bg-[#0A0A0A] text-white">
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <CTASection />
                <Manifesto />
                <FAQ />
            </main>
            <Footer />
        </div>
    );
}

export default App;
